module.exports = __webpack_public_path__ + "static/presidents-message-81711abd2aa06578ebc1ca4a17af2f84.jpg";